import React, { FC, ReactElement, useEffect } from 'react'
import { redirectToServletWithBranding, ServletCmds } from '../../../../NonReact/constants/ServletCommands'
import { Branding } from '../../../../React/Common/API/BrandingAPI'
import { useBranding } from '../../../../React/Common/Hooks/useBranding'
import { APIElements } from '../../../../NonReact/constants/ApiConstants'

export const ReportingPortal: FC = (): ReactElement => {
    const branding: Nullable<Branding> = useBranding()

    useEffect((): void => {
        redirectToServletWithBranding(ServletCmds.RPT_PORTAL, branding?.URLMapping ?? APIElements.AKIXI_2019)
    }, [])

    return <></>
}
